import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { Tooltip } from '@mui/material';
import { BorderlessTooltipProps } from '../../constants/styles';

interface PendingHourglassProps {
  title: string;
  ariaLabel: string;
  fontSize?: 'small' | 'inherit';
}

/** The marker for figures that pending transactions will still move. */
export function PendingHourglass({ title, ariaLabel, fontSize = 'small' }: PendingHourglassProps) {
  return (
    <Tooltip {...BorderlessTooltipProps} title={title} placement='top'>
      <HourglassEmptyIcon
        fontSize={fontSize}
        aria-label={ariaLabel}
        sx={{ color: (theme) => theme.palette.warning.main }}
      />
    </Tooltip>
  );
}
